import PropTypes from 'prop-types';

const styleSheetProp = PropTypes.oneOfType([PropTypes.number, PropTypes.shape({})]);

export default styleSheetProp;
